<template>
  <section class="link">
    <div class="wrap">
      <h2 class="headline" v-if="item.headline">{{ item.headline }}</h2>
      <p>{{ item.body }}</p>

      <a class="underline-link" v-if="item.href" :href="item.href">{{ item.cta }}</a>
      <router-link class="underline-link" v-if="item.route" :to="route">{{ item.cta }}</router-link>

    </div>
  </section>
</template>

<script>
import AbstractSection from './abstract'
import parseUrl from '@/filters/parseurl'

export default AbstractSection.extend({
  computed: {
    route () {
      return parseUrl(this.item.route)
    }
  }
})
</script>

<style lang="scss" scoped>
/* Import from Spar Nord Assets */
@import '~@styles/global/index';
@import '~@styles/colors/variables';
@import '~@styles/mq/variables';
@import '~@styles/mixins/index';
@import '~@animations/easings/variables';
@import '~@animations/durations/variables';

@import '~@helpers/underline-link';

.link {
  position: relative;

  @media #{$above-breakpoint-768} {
    &:after {
      content: "";
      display: block;

      height: 274px;
      width: 671px;

      position: absolute;
      right: 0;
      top: 50%;

      transform: translateY(-50%) translateX(0);

      background: url('https://d2ffutrenqvap3.cloudfront.net/items/3u271R1G1G1B1f2M1n3u/long-el.svg');
      background-repeat: no-repeat;
      background-position: center right;
      background-size: 75%;
    }

    .wrap > * {
      margin-right: 500px;

      @media #{$above-breakpoint-768} {
        margin-left: calc(#{$global-padding} * 2);
        max-width: 500px;
      }
    }
  }
}

h2.headline {
  @include font-size(22px, 30px);
  font-weight: bold;

  margin-bottom: calc(#{$global-padding} * 1.25);

  &:before {
    content: "";
    display: block;
    margin-bottom: $global-padding;

    background: $color-red;
    height: 10px;
    width: 74px;
  }

}

p {
  @include font-size(16px, 18px);
  line-height: 1.4;

  + p {
    margin-top: $global-padding;
  }
}

a {
  color: $color-red;
  font-weight: bold;

  margin-top: calc(#{$global-padding} * 2);

  &:hover {
    color: $color-red-x;
  }
}
</style>



// WEBPACK FOOTER //
// src/sections/link.vue